import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import DroneNameField from 'components/fields/DroneNameField';
import FaaNumberField from 'components/fields/FaaNumberField';

import useTranslation from './hooks/useTranslation';

import { DRONE_NAME_FIELD_NAME, FAA_REGISTRATION_NUMBER_FIELD_NAME, TEST_ID } from './constants';
import type { DroneFormSchema, FieldPath, Props } from './types';

const DroneFormFields = <T extends DroneFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { control } = useFormContext<T>();
    const { DRONE_NAME_FIELD_PLACEHOLDER, FAA_REGISTRATION_NUMBER_FIELD_PLACEHOLDER } =
        useTranslation();

    const fieldName = (name: keyof DroneFormSchema) =>
        (namePrefix ? `${namePrefix}.${name}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            <DroneNameField<T>
                control={control}
                isRequired={true}
                name={fieldName(DRONE_NAME_FIELD_NAME)}
                placeholder={DRONE_NAME_FIELD_PLACEHOLDER}
            />

            <FaaNumberField<T>
                control={control}
                name={fieldName(FAA_REGISTRATION_NUMBER_FIELD_NAME)}
                placeholder={FAA_REGISTRATION_NUMBER_FIELD_PLACEHOLDER}
            />

            {children}
        </FormGrid>
    );
};

export default DroneFormFields;
